import { TERMINOLOGY_TOKENS } from "@app/shared/terminology/terminology-token.catalog";
import { defineTerminologyUsage, TERMINOLOGY_CONFIGURATION_CODES, TERMINOLOGY_USAGE_KINDS } from "@app/shared/terminology/terminology-usage";

export const HEARING_PARTICIPATION_TERMINOLOGY = {
  panel: defineTerminologyUsage({ usageId: "phms.at-hearing.participation.panel", token: TERMINOLOGY_TOKENS.hearingPanel,
    fallbackText: "Hearing Panel", kind: TERMINOLOGY_USAGE_KINDS.templateText, configurationCode: TERMINOLOGY_CONFIGURATION_CODES.programPack,
    surface: { featureCode: "phms", surfaceCode: "hearing-participation", componentCode: "HearingParticipantsSectionComponent",
      locations: [{ kind: "route", value: "/phms/hearing-detail" }] } }),
} as const;
